import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { ApiService } from '../../services/api.service';
import { NgbDateCustomParserFormatter } from '../filters/dateformat'
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, tap, switchMap, max } from 'rxjs/operators';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { isString } from 'util';


@Component({
  selector: 'app-form-loan',
  templateUrl: './form-loan.component.html',
  styleUrls: ['./form-loan.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class FormLoanComponent implements OnInit {

  params: any = {};
  worth: number = 0
  maxPerc: number = 0.95
  lead: any = {
    type: '',
    job: '',
    birthday: {
      day: '',
      month: '',
      year: '',
    }
  };
  birthday;

  days: any = [];
  months: any = [
    {
      description: 'Gennaio',
      value: 1
    },
    {
      description: 'Febbraio',
      value: 2
    },
    {
      description: 'Marzo',
      value: 3
    },
    {
      description: 'Aprile',
      value: 4
    },
    {
      description: 'Maggio',
      value: 5
    },
    {
      description: 'Giugno',
      value: 6
    },
    {
      description: 'Luglio',
      value: 7
    },
    {
      description: 'Agosto',
      value: 8
    },
    {
      description: 'Settembre',
      value: 9
    },
    {
      description: 'Ottobre',
      value: 10
    },
    {
      description: 'Novembre',
      value: 11
    },
    {
      description: 'Dicembre',
      value: 12
    },
  ];
  years: any = [];

  lastResults: any = [];

  stages: any = [
    {
      value: "compromesso",
      description: "Firmato compromesso"
    },
    {
      value: "proposta-acquisto",
      description: "Fatta proposta d'acquisto"
    },
    {
      value: "individuato",
      description: "Individuato immobile"
    },
    {
      value: "ricerca",
      description: "Alla ricerca dell'immobile"
    },
    {
      value: "di-proprieta",
      description: "Immobile già di proprietà"
    },
  ]

  lengths: any = [
    {
      value: 5,
      description: "5 Anni"
    },
    {
      value: 10,
      description: "10 Anni"
    },
    {
      value: 15,
      description: "15 Anni"
    },
    {
      value: 20,
      description: "20 Anni"
    },
    {
      value: 25,
      description: "25 Anni"
    },
    {
      value: 30,
      description: "30 Anni"
    },
 /*    {
      value: 35,
      description: "35 Anni"
    },
    {
      value: 40,
      description: "40 Anni"
    }, */

  ]

  purposes: any = [
    {
      value: "prima-casa",
      description: "Acquisto prima casa"
    },
    {
      value: "seconda-casa",
      description: "Acquisto seconda casa"
    },
    {
      value: "asta",
      description: "Acquisto all'asta"
    },
   /*  {
      value: "surroga",
      description: "Surroga"
    }, */
    {
      value: "rifinanziamento",
      description: "Rifinanziamento"
    },
    {
      value: "ristrutturazione",
      description: "Ristutturazione"
    },
/*     {
      value: "altro",
      description: "Altro"
    }, */
  ]

  maxDate: NgbDateStruct = {
    day: (new Date()).getDay(),
    month: (new Date()).getMonth(),
    year: (new Date()).getFullYear() - 18
  };
  minDate: NgbDateStruct = {
    day: 1,
    month: 1,
    year: 1910
  };
  buyerFound: boolean = true;
  showSMS: boolean = false;
  showCall: boolean = false;
  leadId: string;
  searching: boolean = false;
  errors: any = [];
  nextStep = false;
  stepCount = 0;
  loading: boolean = false;
  code: string = "";
  error: boolean = false;
  editPhone: boolean = false;
  color: string = "#28a745"; // hover color #218838
  bgColor: string = this.color;
  buyer: any;
  oldBuyers: any = [];


  jobs: any;

  constructor(
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private api: ApiService,
    private calendar: NgbCalendar
  ) { }

  ngOnInit() {


    this.route.queryParams.subscribe(params => {
      this.params = params;
      this.lead.affiliate = this.params.aff_id;
      this.lead.host = this.params.host;
      this.lead.aff_ref = this.params.aff_ref;
      this.lead.url = this.params.url;


      if (this.params.btn_color) {
        this.color = this.params.btn_color;
        this.bgColor = this.params.btn_color;
      }

      for (let i = 1; i <= 31; i++) {
        this.days.push({ value: i, description: i });
      }

      for (let i = 1900; i <= this.maxDate.year; i++) {
        this.years.push({ value: i, description: i });
      }
      this.years.reverse();

      if (localStorage.getItem('el_oldBuyers_Loans')) {
        this.oldBuyers = JSON.parse(localStorage.getItem('el_oldBuyers_Loans'));
      }


      if (localStorage.getItem('userLoan')) {
        const lead = JSON.parse(localStorage.getItem('userLoan'));

        if (lead.owner !== 'eleads') {
          this.oldBuyers.push(lead.owner);
        }
      }



    });


    this.cd.detectChanges();
  }




  check(property) {
    let amount = (isString(this.lead.amount)) ? parseInt(this.lead.amount.replace(/\./g, "")) : this.lead.amount;
    let worth = (isString(this.lead.worth)) ? parseInt(this.lead.worth.replace(/\./g, "")) : this.lead.worth;
    this.worth = worth;
    switch (property) {
      case 'gender':

        if (this.lead.gender) {
          this.errors['gender'] = false;
        } else {
          this.errors['gender'] = true;
        }

        break;


      case 'purpose':

        if (this.lead.purpose) {
          this.errors['purpose'] = false;

          if(this.lead.purpose == "prima-casa"){
            this.maxPerc = 0.95
          } else  {
            this.maxPerc = 0.8
          }

        } else {
          this.errors['purpose'] = true;
        }

        break;

      case 'stage':

        if (this.lead.stage) {
          this.errors['stage'] = false;

        
        } else {
          this.errors['stage'] = true;
        }

        break;

      case 'length':

        if (this.lead.length) {
          this.errors['length'] = false;
        } else {
          this.errors['length'] = true;
        }

        break;

      case 'amount':
        if (amount >= 30000 && amount <= 1000000) {
          this.errors['amount'] = false;
          if(worth){
            let maxworth = this.maxPerc * worth
            if (amount > maxworth) {
              this.errors['amount_worth'] = true;
            } else {
              this.errors['amount_worth'] = false;
            }
          }
        } else {
          this.errors['amount'] = true;
        }

        break;

      case 'worth':

        if (worth >= 30000 && worth <= 10000000) {
          this.errors['worth'] = false;

          let maxworth =  this.maxPerc * worth

          if (amount > maxworth) {
            this.errors['amount_worth'] = true;
            this.errors['amount'] = true;
          } else {
            this.errors['amount_worth'] = false;
            if (amount >= 30000 && amount <= 1000000) {
              this.errors['amount'] = false;
            } else {
              this.errors['amount'] = true;
            }
          }

        } else {
          this.errors['worth'] = true;
        }


        break;


      case 'name':

        if (this.lead.name.length >= 2) {
          this.errors['name'] = false;
        } else {
          this.errors['name'] = true;
        }

        break;

      case 'surname':

        if (this.lead.surname.length >= 2) {
          this.errors['surname'] = false;
        } else {
          this.errors['surname'] = true;
        }

        break;

      case 'birthday':

        const maxDay = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if ((this.lead.birthday.year >= 1900 && this.lead.birthday.year < this.maxDate.year) && (this.lead.birthday.month > 0 && this.lead.birthday.month <= 12) && (this.lead.birthday.day > 0 && this.lead.birthday.day <= maxDay[this.lead.birthday.month - 1])) {
          this.errors['birthday'] = false;
        } else {
          this.errors['birthday'] = true;
        }


        break;

      case 'email':
        this.errors['email'] = this.eleads_validate_email(this.lead.email)
        break;

      case 'phone':
        this.errors['phone'] = this.eleads_validate_phone(this.lead.phone)
        break;

      case 'zip':

        if (this.lead.zip.name && this.lead.zip.zipcode) {
          this.errors['zip'] = false;
        } else if (this.lastResults.length > 0) {
          this.lead.zip = this.lastResults[0];
          this.getSetup(this.lead.zip.zipcode, this.lead.affiliate, this.lead.purpose, this.lead.length);
          this.errors['zip'] = false;
        } else {
          this.errors['zip'] = true;
        }

        break;


      case 'hometown':
        if (this.lead.hometown.name && this.lead.hometown.zipcode) {
          this.errors['hometown'] = false;
        } else if (this.lastResults.length > 0) {
          this.lead.hometown = this.lastResults[0];
          this.errors['hometown'] = false;
        } else {
          this.errors['hometown'] = true;
        }
        break;

      default:
        if (this.lead[property] !== '') {
          this.errors[property] = false;
        } else {
          this.errors[property] = true;
        }
        break;
    }

    console.log(this.errors)
  }

  getSetup(zipcode, affiliate_id, purpose, length) {

    this.loading = true;


    this.api.setupLoan(zipcode, affiliate_id, this.oldBuyers, purpose, length)
      .subscribe(data => {
        this.buyer = data;
        this.lead.owner = this.buyer.id;
        this.buyerFound = true;
        this.lead.needToVerify = this.buyer.needToVerify;
        this.lead.needToQualify = this.buyer.needToQualify;

        if (data.blocked) {
          this.lead.affiliate = "";
        }

        this.loading = false;
      }, error => {
        this.buyerFound = false;
      });
  }

  formatMatches = (value: any) => value.zipcode + ' - ' + value.name || '';
  formatMatchesInput = (value: any) => value.zipcode || '';
  selectedItem(item) {
    this.lead.city = item.item.name;
    this.errors['zip'] = false;
    this.getSetup(item.item.zipcode, this.lead.affiliate, this.lead.purpose, this.lead.length);
  };


  formatMatchesHometown = (value: any) => value.zipcode + ' - ' + value.name || '';
  formatMatchesInputHometown = (value: any) => value.zipcode || '';
  selectedItemHometown(item) {
    this.lead.hometown = item.item.name;
    this.errors['hometown'] = false;
  };

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.api.getLocation(term)
          .pipe(
            tap((obj: any) => {
              this.lastResults = [];
              this.lastResults = obj;
            }),
            catchError(() => {
              return of([]);
            }))
      ),
      tap(() => this.searching = false)
    )

  searchHometown = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.api.getLocation(term)
          .pipe(
            tap((obj: any) => {
              this.lastResults = [];
              this.lastResults = obj;
            }),
            catchError(() => {
              return of([]);
            }))
      ),
      tap(() => this.searching = false)
    )


  eleads_validate_email(email) {
    email = email.replace(/ /g, "");
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !re.test(String(email).toLowerCase());
  }

  eleads_validate_phone(phone) {
    phone = phone.replace(/ /g, "");
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2,3}[-\s\.]?[0-9]{3,6}$/im;
    return !re.test(String(phone).toLowerCase());
  }

  eleads_validate_cap(cap) {
    var re = /^[0-9]{5}$/;
    return !re.test(String(cap).toLowerCase());
  }

  verify() {
    this.loading = true;
    var code = { code: this.code };
    this.api.verifyLoan(this.leadId, code).subscribe(
      success => {
        this.loading = false;
        this.stepCount++;
        this.oldBuyers.push(this.buyer.id)

        let sold = true;

        if (this.buyer.id === "eleads") {
          sold = false;
        } else {
          localStorage.setItem("el_oldBuyers_Loans", JSON.stringify(this.oldBuyers));
        }

        window.parent.postMessage({ sender: 'e-leads', message: "done", id: this.leadId, sold }, '*');
      },
      error => {
        this.loading = false;
        this.error = true;
      });
  }

  next() {
    // this.lead.zip=this.lead.zip.zipcode; //we need to do this before sending the data
    let amount = (isString(this.lead.amount)) ? parseInt(this.lead.amount.replace(/\./g, "")) : this.lead.amount;
    let worth = (isString(this.lead.worth)) ? parseInt(this.lead.worth.replace(/\./g, "")) : this.lead.worth;
    this.worth = worth;
    var goOn = true;
    switch (this.stepCount) {

      case 0:

        if (this.lead.stage) {
          this.errors['stage'] = false;
        } else {
          goOn = false;
          this.errors['stage'] = true;
        }

        if (!this.lead.name || this.errors['name']) {
          goOn = false;
          this.errors['name'] = true;
        } else {
          this.errors['name'] = false;
        }

        if (!this.lead.surname || this.errors['surname']) {
          goOn = false;
          this.errors['surname'] = true;
        } else {
          this.errors['surname'] = false;
        }

        var maxDay = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if ((this.lead.birthday.year >= 1900 && this.lead.birthday.year < this.maxDate.year) && (this.lead.birthday.month > 0 && this.lead.birthday.month <= 12) && (this.lead.birthday.day > 0 && this.lead.birthday.day <= maxDay[this.lead.birthday.month - 1])) {
          this.errors['birthday'] = false;
        } else {
          this.errors['birthday'] = true;
          goOn = false
        }

        if (goOn) {
          this.stepCount++;
          this.birthday = this.lead.birthday;
          window.scrollTo(0, 0);
        }
        break;

      case 1:



        if (!this.lead.zip || this.errors['zip']) {
          goOn = false;
          this.errors['zip'] = true;
        } else {
          this.errors['zip'] = false;
        }

        if (this.buyer.fiscalCode) {
          if (!this.lead.hometown || this.errors['hometown']) {
            goOn = false;
            this.errors['hometown'] = true;
          } else {
            this.errors['hometown'] = false;
          }
        }



        if (goOn) {
          this.stepCount++;
          window.scrollTo(0, 0);
        }
        break;

      case 2:


        if (!this.lead.phone || this.errors['phone']) {
          goOn = false;
          this.errors['phone'] = true;
        } else {
          this.errors['phone'] = false;
        }

        if (!this.lead.email || this.errors['email']) {
          goOn = false;
          this.errors['email'] = true;
        } else {
          this.errors['email'] = false;
        }

        if (this.buyer.id == "eleads") {
          if (!this.lead.privacy_data) {
            goOn = false;
            this.errors['privacy_data'] = true;
          } else {
            this.errors['privacy_data'] = false;
          }
        } else {

          this.buyer.privacies.map(privacy => {
            if (privacy.required) {
              if (!this.lead[privacy.paramName]) {
                goOn = false;
                this.errors[privacy.paramName] = true;
              } else {
                this.errors[privacy.paramName] = false;
              }
            }
          })

        }



        if (goOn) {
          this.loading = true;
          var lead = this.lead;
          lead.cap = lead.zip.zipcode;
          this.api.postLeadLoan(this.lead).subscribe(
            (id: any) => {
              var verify = this.lead.needToVerify;

              if (verify) {
                this.leadId = id.id;
                this.stepCount++;
                this.loading = false;
                this.api.sendSMSLoan(this.leadId).subscribe();
                window.parent.postMessage({ sender: 'e-leads', message: "verify", id: this.leadId }, '*');
              } else {
                this.leadId = id.id;
                this.stepCount += 2;
                this.loading = false;
                let sold = (this.buyer.id !== "eleads") ? true : false;
                window.parent.postMessage({ sender: 'e-leads', message: "done", id: this.leadId, sold }, '*');
              }

              

              window.scrollTo(0, 0);
            }, error => {
              this.loading = false;
              this.error = true;
              window.scrollTo(0, 0);
            }
          )
        }
        break;

      case 4:

        break;

      default:
        break;
    }




  }


  sendSMS() {
    var phone = { phone: this.lead.phone }
    this.api.editPhoneLoan(this.leadId, phone)
      .subscribe(success => {
        this.api.sendSMSLoan(this.leadId).subscribe(
          success => {
            this.showSMS = true;
          },
          error => {
            this.error = true;
          });
      });
  }

  sendCall() {
    var phone = { phone: this.lead.phone }
    this.api.editPhoneLoan(this.leadId, phone)
      .subscribe(success => {
        this.api.sendCallLoan(this.leadId)
          .subscribe(
            success => {
              this.showCall = true;
            },
            error => {
              this.error = true;
            });
      }, error => {
        this.error = true;
      });
  }

  prev() {
    // this.lead.zip=this.lead.zip.zipcode; //we need to do this before sending the data
    this.stepCount--;
  }

  checkData(step) {
    var goOn = false;
    switch (step) {
      case 0:

        break;
    }

  }


  registerClick() {
    this.api.registerClick(this.leadId, this.buyer.id).subscribe()
  }

  mouseEnter() {
    var rgb = this.hexToRgb(this.color);

    // create a darker shade for hover effect
    rgb.r *= 0.8;
    rgb.g *= 0.8;
    rgb.b *= 0.8;

    this.bgColor = this.rgbToHex(rgb.r, rgb.g, rgb.b);
  }

  mouseLeave() {
    this.bgColor = this.color;
  }

  //-------------------------------- FUNCTION TO TRANSFORM HEX COLOR TO RGB AND BACK

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  rgbToHex(red, green, blue) {
    var rgb = blue | (green << 8) | (red << 16);
    return '#' + (0x1000000 + rgb).toString(16).slice(1)
  }

  public onFocusSelect(e: Event): void {
    e.stopPropagation();
    setTimeout(() => {
      const inputEvent: Event = new Event('input');
      e.target.dispatchEvent(inputEvent);
    }, 0);
  }


}
